import { Navigate } from 'react-router';

/** Legacy route: /app/help now redirects to dashboard; Alex opens as a drawer. */
export function HelpPage() {
  return <Navigate to="/app" replace />;
}
